import { makeStyles } from "tss-react/mui";

const gapBetweenButtons = 1;

export const useNWONCTASectionStyles = makeStyles()((theme) => ({
  wrapper: {
    padding: theme.spacing(5, 0),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3, 0),
    },
  },
  innerWrapper: {
    maxWidth: theme.breakpoints.values.md,
  },
  title: {
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(2),
    },
  },
  teamMemberName: {
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(0.5),
    },
  },
  subtitle: {
    marginBottom: theme.spacing(2),
  },
  buttonsWrapper: {
    columnGap: theme.spacing(gapBetweenButtons),
    rowGap: theme.spacing(gapBetweenButtons),
  },
  buttonWrapper: {
    "& > *": {
      width: "100%",
      "& > a": {
        width: "100%",
      },
    },
    width: "70%",
    [theme.breakpoints.only("sm")]: {
      // To have 2 buttons where the width of each corresponds to 50% of the row, we have to take into account the gap between them
      width: `calc(50% - ${gapBetweenButtons / 2}rem)`,
    },
    [theme.breakpoints.only("xs")]: {
      width: "100%",
    },
  },
  bubblesWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    [theme.breakpoints.up("md")]: {
      paddingTop: "5%",
    },
  },
  teamMemberBubble: {
    width: theme.spacing(16),
    height: theme.spacing(16),
    margin: "0 auto",
    position: "relative",
    "& > span": {
      borderRadius: "50%",
      boxShadow: `0px 0px 12px -6px ${theme.palette.secondary.main}`,
    },
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(5),
    },
  },
  logoBubble: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    margin: "0 auto",
    backgroundColor: theme.palette.background.default,
    display: "flex",
    padding: theme.spacing(1),
    borderRadius: "50%",
    boxShadow: `0px 0px 12px -6px ${theme.palette.secondary.main}`,
    position: "absolute",
    top: theme.spacing(11),
    right: theme.spacing(-5),
    [theme.breakpoints.down("sm")]: {
      right: theme.spacing(-3),
    },
  },
}));
